import React, { useState, useEffect } from 'react';
import { FaTasks, FaCheckCircle, FaClock } from 'react-icons/fa';
import { getApiEndpoint } from '../../../config/api';
import './StaffDashboard.css';

export default function MyTasks() {
  const [tasks, setTasks] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTasks = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const url = filter === 'all'
          ? getApiEndpoint('/api/staff/tasks')
          : getApiEndpoint(`/api/staff/tasks?status=${filter}`);
        const res = await fetch(url, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        setTasks(data.tasks || []);
      } catch (err) {
        setTasks([]);
      }
      setLoading(false);
    };
    fetchTasks();
  }, [filter]);

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <div className="task-controls">
        <div className="filter-controls">
          <label>Status:</label>
          <select value={filter} onChange={e => setFilter(e.target.value)}>
            <option value="all">All</option>
            <option value="pending">Pending</option>
            <option value="in_progress">In Progress</option>
            <option value="completed">Completed</option>
          </select>
        </div>
      </div>
      <div className="tasks-list">
        {tasks.map(task => (
          <div className="task-card" key={task.id}>
            <div className="task-header">
              <h4>{task.title}</h4>
              <span className={`status ${task.status}`}>{task.status.replace('_', ' ')}</span>
            </div>
            <div className="task-property">Property: {task.property_name}</div>
            <div className="task-footer">
              <span className="due-date"><FaClock /> Due: {task.due_date}</span>
              {task.status === 'completed' && <FaCheckCircle color="#27ae60" />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 